<template>
	<div class="game__panel panelka" :class="active ? 'active' : ''" v-if="$parent.start && !$parent.finish && $parent.user.role.code == 'teacher'">
		<div class="panelka__cifs">
			<label class="panelka__wrap">
				<span class="panelka__users" uk-tooltip="Количество игроков"></span>
				<div class="plm">
					<div class="plm__button plm__button--minus" @click="$parent.addUsers('-')"></div>
					<input type="number" min="1" max="8" readonly v-model="$parent.users">
					<div class="plm__button plm__button--plus" @click="$parent.addUsers('+')"></div>
				</div>
			</label>
		</div>
		<div class="panelka__link">
			<a href="#" class="panelka__button panelka__button--stop" @click.prevent="$parent.commitVal(false, 'start')" uk-tooltip="Остановить"></a>
		</div>
		<div class="panelka__link">
			<a href="#" class="panelka__button panelka__button--play" id="start" @click.prevent="fullStart" uk-tooltip="Запуск/Повтор"></a>
		</div>
		<div class="panelka__link">
			<a href="#" class="panelka__button panelka__button--check" id="check" @click.prevent="fullCheck" uk-tooltip="Проверить"></a>
		</div>
		<a class="panelka__expand" @click="active = !active"  :uk-tooltip="active ? 'Свернуть' : 'Раскрыть'"></a>
	</div>
</template>

<script>
  export default {
    name: "panelka",
    data() {
      return {
        active: false
      }
    },
    props: {
      items: ''
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
      fullStart() {
        this.$root.$emit('fullStart');
      },
      fullCheck() {
        //console.log('FullCheck', this.users);
        let inputs = $('.game_input');
        let qnt = inputs.length;
        let step = 0;
        $(inputs).each(function () {
          let el = $(this);
          let val = el.val();
          if (val) {
            step++;
          } else {
            el.addClass('error');
            setTimeout(function () {
              el.removeClass('error')
            }, 2500);
          }
        });
        if (this.$parent.users > 1 || step === qnt) {
          console.log('FullCheck прошел');
          this.$root.$emit('fullCheck');
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.panelka__link a {
  border: none;
}
</style>